<!-- =========================================================================================
  File Name: OrderView.vue
  Description: Order View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="orderSheet-view-tab-information">
    <!-- INVOICE METADATA -->
    <div class="vx-row leading-loose p-base">
        <div class="vx-col w-1/2 mt-base">
            <img src="@/assets/images/logo/logo.png" alt="vuexy-logo">
        </div>
        <div class="vx-col w-1/2 text-right">
            <h1>Invoice</h1>
            <div class="invoice__invoice-detail mt-6">
                <h6 class="mt-4">주문일</h6>
                <p>{{ order_data.orderCreateDate }}</p>
            </div>
        </div>
        <div class="vx-col w-1/2 mt-12">
            <h5>배송지</h5>
            <div class="invoice__recipient-info my-4">
                <p>({{ order_data.recvZipCode }}) {{ order_data.recvZipName }}</p>
                <p>{{ order_data.recvZipDetail }} {{ order_data.recvUserName }}</p>
            </div>
            <div class="invoice__recipient-contact ">
                <p class="flex items-center">
                    <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ order_data.recvUserPhone }}</span>
                </p>
                <p class="flex items-center">
                    <feather-icon icon="SmartphoneIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ order_data.recvUserSMSPhone }}</span>
                </p>
                <p v-if="order_data.recvUserEmail" class="flex items-center">
                    <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ order_data.recvUserEmail }}</span>
                </p>
            </div>
        </div>
        <div class="vx-col w-1/2 mt-base text-right mt-12">
            <h5>주문자</h5>
            <div class="invoice__company-info my-4">
                <p>{{ order_data.orderUserName }}</p>
            </div>
            <div class="invoice__company-contact">
                <p class="flex items-center justify-end">
                    <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ order_data.orderUserPhone }}</span>
                </p>
                <p class="flex items-center justify-end">
                    <feather-icon icon="SmartphoneIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ order_data.orderUserSMSPhone }}</span>
                </p>
                <p v-if="order_data.orderUserEmail" class="flex items-center justify-end">
                    <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
                    <span class="ml-2">{{ order_data.orderUserEmail }}</span>
                </p>
                <p class="flex items-center justify-end">
                  <!-- <feather-icon icon="AlertOctagonIcon" svgClasses="h-4 w-4"></feather-icon> -->
                  <span class="ml-2">{{ order_data.orderMemo }}</span>
                </p>
            </div>

        </div>
    </div>
    <!-- INVOICE CONTENT -->
    <div class="p-base">
        <!-- INVOICE TASKS TABLE -->
        <vs-table hoverFlat :data="orderProductList" stripe>
            <!-- HEADER -->
            <template slot="thead">
                <vs-th class="pointer-events-none">교재정보</vs-th>
                <vs-th class="pointer-events-none">교재단가(권 당)</vs-th>
                <vs-th class="pointer-events-none">수량</vs-th>
                <vs-th class="pointer-events-none">교재합계</vs-th>
            </template>

            <!-- DATA -->
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].productName">{{ data[indextr].productName }}</vs-td>
                    <vs-td :data="data[indextr].price">{{ String(data[indextr].price).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 원</vs-td>
                    <vs-td :data="data[indextr].orderCount">{{ data[indextr].orderCount }}</vs-td>
                    <vs-td>{{ String(data[indextr].orderCount * data[indextr].price).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 원</vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <!-- INVOICE SUMMARY TABLE -->
        <!-- <vs-table hoverFlat class="w-1/2 ml-auto mt-4">
          <vs-tr>
              <vs-th class="pointer-events-none">주문금액</vs-th>
              <vs-td>{{ String(order_data.buyMoney).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 원</vs-td>
          </vs-tr>
          <vs-tr>
              <vs-th class="pointer-events-none">배송비</vs-th>
              <vs-td>{{ deliveryCharges }} 원</vs-td>
          </vs-tr>
          <vs-tr>
              <vs-th class="pointer-events-none">할인</vs-th>
              <vs-td>-0 원</vs-td>
          </vs-tr>
          <vs-tr>
              <vs-th class="pointer-events-none">총 결제 금액</vs-th>
              <vs-td>{{ String(order_data.realTakeMoney).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 원</vs-td>
          </vs-tr>
        </vs-table> -->
        <table class="w-1/2 ml-auto mt-4" style="border: 1px solid lightgray;">
          <tr>
              <td class="pointer-events-none">주문금액</td>
              <td>{{ String(order_data.buyMoney).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 원</td>
          </tr>
          <tr>
              <td class="pointer-events-none">배송비</td>
              <td>{{ deliveryCharges }} 원</td>
          </tr>
          <!-- <tr>
              <td class="pointer-events-none">할인</td>
              <td>-0 원</td>
          </tr> -->
          <tr>
              <td class="pointer-events-none text-danger">총 결제 금액</td>
              <td class="text-danger">{{ String(order_data.realTakeMoney).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 원</td>
          </tr>
        </table>
    </div>

    <!-- INVOICE FOOTER -->
    <div class="invoice__footer text-right p-base">
        <p class="mb-4">(주)엘이디에듀<p>
            <!-- <span class="mr-8">기업: <span class="font-semibold">221-328695-04-016</span></span> -->
            <span>기업: <span class="font-semibold">221-328695-04-016 </span></span>
        </p>
    </div>

  </div>
</template>

<script>
import { fetchData } from '@/api/module'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      order_data: this.data,
      orderProductList: []
    }
  },
  computed: {
    deliveryCharges () {

      let deliveryCharge = false
      for (let i = 0; i < this.orderProductList.length; i++) {
        if (this.orderProductList[i].productType === 0) {
          deliveryCharge = true
          break
        }
      }

      if (deliveryCharge) {
        //const buyMoney = Number(this.order_data.buyMoney)
        //if (buyMoney > 250000) {
        //  return '무료배송'
        //} else {
        return `${String(3000).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
        //}
      } else {
        return '무료배송'
      }
    }
  },
  methods: {
    async loadItems () {
      try {
        const orderSheetSeq = this.$route.params.orderSheetSeq
        const { data } = await fetchData(`order/${orderSheetSeq}/product`)
        this.orderProductList = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.loadItems()
  },
  mounted () {
    //console.log(this.order_data)
  }
}

</script>

<style lang="scss">
// #avatar-col {
//   width: 10rem;
// }

// #page-order-view {
//   table {
//     td {
//       vertical-align: top;
//       min-width: 140px;
//       padding-bottom: .8rem;
//       word-break: break-all;
//     }

//     &:not(.permissions-table) {
//       td {
//         @media screen and (max-width:370px) {
//           display: block;
//         }
//       }
//     }
//   }
// }


// @media screen and (min-width:1201px) and (max-width:1211px),
// only screen and (min-width:636px) and (max-width:991px) {
//   #account-info-col-1 {
//     width: calc(100% - 12rem) !important;
//   }

// }

</style>
